import { computed } from 'vue';
import { format, milliseconds, differenceInDays, startOfTomorrow } from 'date-fns';
import { getMiddleDate } from '@entities/searchCriteria/checkInDate';
import wordEnding from '@/js/common/Domain/Service/mixins/wordEnding';
import { useCheckInDateRangeStore } from '@entities/searchCriteria/checkInDate';
import { useNightsRangeStore } from '@entities/searchCriteria/nightsRange';
import updateStoreNightRange from './updateStoreNightRange';

export default (props: { modelPrefix: string }) => {
    const { nightRange } = useNightsRangeStore(props.modelPrefix);
    const { checkInDateRange } = useCheckInDateRangeStore(props.modelPrefix);
    const { updateStoreNightRangeFrom, updateStoreNightRangeTo } = updateStoreNightRange(props.modelPrefix);
    const checkInDateRangeLabel = computed(() => {
        const dateFrom = checkInDateRange.value?.from ?? false;
        const dateTo = checkInDateRange.value?.to ?? false;
        const daysFlexible = checkInDateRange.value?.daysFlexible;
        const label = {
            mainDateLabel: '',
            plusMinOneDayLabel: '',
        };
        const daysRange = daysFlexible || 0;
        if (dateFrom && dateTo && dateFrom.getTime() !== dateTo.getTime()) {
            const middleDate = getMiddleDate({ from: dateFrom, to: dateTo, daysFlexible });
            const availableSearchDate = startOfTomorrow();
            const diffDays = Math.abs(differenceInDays(middleDate, availableSearchDate));
            if (diffDays >= daysRange && daysRange) {
                label.mainDateLabel = `${format(middleDate, 'dd.MM')}`;
                label.plusMinOneDayLabel = `(± ${daysRange} ${wordEnding(daysRange, 'день;дня;дней')})`;
            } else {
                label.mainDateLabel = `${format(dateFrom, 'dd.MM')} по ${format(dateTo, 'dd.MM')}`;
                label.plusMinOneDayLabel = '';
            }
        } else if (dateFrom && dateTo) {
            label.mainDateLabel = `${format(dateFrom, 'dd.MM')}`;
            label.plusMinOneDayLabel = '';
        }

        return label;
    });

    const nightsLabel = computed(() => {
        const nightRangeFrom = nightRange.value?.from ?? false;
        const nightRangeTo = nightRange.value?.to ?? false;
        let label = '';

        if (nightRangeFrom && nightRangeTo && nightRangeFrom !== nightRangeTo) {
            label = `${nightRangeFrom} - ${nightRangeTo} ноч${wordEnding(nightRangeTo, 'ь;и;ей')}`;
        } else if (nightRangeFrom) {
            label = `${nightRangeFrom} ноч${wordEnding(nightRangeFrom, 'ь;и;ей')}`;
        }

        return label;
    });

    return {
        nightRange,
        updateStoreNightRangeFrom,
        updateStoreNightRangeTo,
        checkInDateRangeLabel,
        nightsLabel,
    };
};